

for (var i = 0; i < document.querySelectorAll('.collection-slider__swiper').length; i++) {
  const elArray = document.querySelectorAll('.collection-slider__swiper');
  if (!elArray[i].classList.contains('initiated')) {
    elArray[i].classList.add('initiated')
    const featuredCollectionSwiper = new Swiper (elArray[i], {
      slidesPerView: 'auto',
      loop: false,
      allowTouchMove: true,

      mousewheel: {
        forceToAxis: true
      },
      navigation: {
        nextEl: '.swiper-next',
        prevEl: '.swiper-prev',
      },
    });


    const $currentSwiper = $(elArray[i]);
    const $parent = $currentSwiper.closest('.collection-slider');

    if ($parent.hasClass('collection-slider--filtered')) {
      const $navigation = $parent.find('.swiper-navigation');
      const $filterLinks = $parent.find('.collection-slider__filters a');
      $currentSwiper.css('height', $currentSwiper.innerHeight() + 'px');
      $navigation.css('height', $navigation.innerHeight() + 'px');

      $filterLinks.on('click', function (e) {
        e.preventDefault();

        if (!$(this).hasClass('temp-disable')) {
          $filterLinks.addClass('temp-disable');


          if (!$(this).hasClass('active-filter')) {
            // FILTER BY A COLLECTION
            const collectionHandle = $(this).attr('data-collection-title');

            $parent.addClass('has-active-filter');
            $filterLinks.removeClass('active-filter');
            $(this).addClass('active-filter');

            $parent.find('.js-filtered-slide').hide();
            $parent.find(`.js-filtered-slide[data-collections*="${collectionHandle}"]`).fadeIn();

          } else {
            //  CLEAR FILTERS
            $parent.removeClass('has-active-filter');
            $('.active-filter').removeClass('active-filter');
            $parent.find('.js-filtered-slide').fadeIn();
          }

          featuredCollectionSwiper.update(true)
          featuredCollectionSwiper.slideTo(0)

          $filterLinks.removeClass('temp-disable');
        }



      });

    }


  }


}
